// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G4HZneOVs8PxDVaEAxCE{align-items:center;gap:10px;display:flex}.GYkrQXKCL78kOyGUFtK5{margin-top:24px}.lcLCYm3e0sK65jBbkKVO{flex-direction:column;gap:4px;margin-top:24px;display:flex}.lcJPLZr9MdWuKyfc3RNA{letter-spacing:-.4px;max-width:256px}.HSnN6WeGkzU_EEetCjcm{max-width:226px}.y0bHRtPJWdspGtKHguBL{justify-content:center;align-items:center;width:175px;height:177px;margin-top:3px;margin-bottom:17px;display:flex}.evgZoRSoiU4kmTRnSQ3s{width:auto;max-width:100%;height:auto;max-height:100%;display:block}.zNpbT1fowGcuciChazbF{justify-content:center;align-items:center;gap:8px;width:100%;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWrap": `G4HZneOVs8PxDVaEAxCE`,
	"bodyWrap": `GYkrQXKCL78kOyGUFtK5`,
	"paramsWrap": `lcLCYm3e0sK65jBbkKVO`,
	"name": `lcJPLZr9MdWuKyfc3RNA`,
	"title": `HSnN6WeGkzU_EEetCjcm`,
	"image": `y0bHRtPJWdspGtKHguBL`,
	"qrImage": `evgZoRSoiU4kmTRnSQ3s`,
	"actions": `zNpbT1fowGcuciChazbF`
};
export default ___CSS_LOADER_EXPORT___;
